export const TECHNICAL_TEST_LINK_SYMBOL = '|';
 